import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { ActionTrace } from '../components/ActionTrace';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { NovaSection } from '../components/nova/NovaSection';
import { SlackIntegrationGraphCardMorph } from '../components/SlackIntegrationGraphCardMorph';
// New Giga home screen. The hero is the "Ask Giga anything, get it done."
// chat-box composer (HowItWorksConnections in hero mode), presented as a
// proper website hero. The Slack "@mention Giga" experience remains its own
// "Works where you work" section further down the page.
// The "AI Co-Pilot for Teams" homepage still lives at /future.
export function Home() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4623" />
      {/* <NovaSection /> Hidden per user request */}
      {/* "Works where you work" → "Works right in your chats" now uses the
                refined card-morph transition (typed "@Giga …" prompt that resolves
                into the chat panel) that we proved out on /chat-transition. */}
      <SlackIntegrationGraphCardMorph data-id="element-4624" />
      {/* "How it works" / Plug-and-play moved above the Giga for You / Team
                        audience switch per the intended narrative flow. */}
      <GettingStartedSteps data-id="element-4625" />
      <AudienceSwitch data-id="element-4626" />
      {/* <LivesInSlack /> Hidden from home for now — kept for reuse on another page later */}
      {/* Action trace proof ("Built to do the work…") leads, then the
                    "Giga brings its own computer" proof beat — which stays ahead of the
                    reviews (WallOfLove) below. */}
      <ActionTrace data-id="element-4627" />
      <ComputerUse data-id="element-4628" />
      <NarrativeSection data-id="element-4629" />
      <ToolComparison data-id="element-4630" />
      <WallOfLove data-id="element-4631" />
      {/* <PricingSection /> Hidden from home for now — still a waitlist. Kept
                    for reuse; bring back when pricing goes live. */}
      <ClosingCTA data-id="element-4632" />
    </>;
}